/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AppAutobuildType = core.serialization.enum_(["FILE", "FIELDS", "PROMPT", "COMBINED", "EMPTY", "FLATFILEOS"]);
